import {NgModule, Component} from '@angular/core';
import {Input, Output,EventEmitter} from '@angular/core';
import {BrowserModule}   from '@angular/platform-browser';
import {DialogModule,ButtonModule,CalendarModule,DropdownModule,InputTextModule} from 'primeng/primeng';
import {CommonModule, DatePipe} from "@angular/common";
import {HttpModule} from "@angular/http";
import {RouterModule} from "@angular/router";
import {FormsModule} from "@angular/forms";
import {SelectItem} from "primeng/components/common/api";
import {SearchItem} from "../model/search";
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS
import {TranslateServiceForm, TranslatePipeMoudle} from "../translate";


@Component({
  selector:'searchDropbox',
  templateUrl:'search_dropbox.component.html'
})
export class SearchDropBoxComponent {
  sDate: string;
  eDate: string;
  selectedSearchID : string;
  selectedSearchTextDropBox : any;
  selectedOsType : string;

  searchText : string;
  searchItem : SearchItem;
  @Input() dateIsTrue;
  @Input() excelIsTrue : boolean = false;
  @Input() insaSyncIsUse : boolean = false;
  @Input() searchTextIsUse;
  @Input() searchTextIsDropBox;
  @Input() searchOsTypeIsDropBox = false;
  @Input() searchTextDropBox:SearchItem[];
  @Input() searchOsTypeDropBox : SearchItem[];
  @Input() searchIDs : SelectItem[];
  @Input() searchDropBoxIsUse : boolean = true;

  @Output() passingModel = new EventEmitter();
  @Output() searchTextChage = new EventEmitter();
  @Output() excelDownStatus = new EventEmitter();
  @Output() osTypeChangeValue = new EventEmitter();
  @Output() osTypeChange = new EventEmitter();
  @Output() startDBSync = new EventEmitter();

  private logger : Logger = new Logger();

  searching(){
    let datePipe = new DatePipe("en");

    let search_text : any;
    this.logger.debug(this.selectedSearchTextDropBox);


    this.searchItem = new SearchItem(datePipe.transform(this.sDate, 'yyyy-MM-dd'),datePipe.transform(this.eDate, 'yyyy-MM-dd'),this.selectedSearchID, this.searchText ,true);
    //this.searchModel = new Model(datePipe.transform(this.sDate, 'yyyy-MM-dd'),datePipe.transform(this.eDate, 'yyyy-MM-dd'),this.selectedSearchID, this.searchText);
    this.logger.debug(datePipe.transform(this.sDate, 'yyyy-MM-dd'));
    this.logger.debug(datePipe.transform(this.eDate, 'yyyy-MM-dd'));
    this.logger.debug(this.selectedSearchID);
    this.logger.debug(this.searchText);

    this.logger.debug("value : ", this.searchItem);
    /*searchMod.searchId = this.selectedSearchID;
    searchMod.searchText = this.searchText;
    searchMod.sDate = datePipe.transform(this.sDate, 'yyyy-MM-dd');
    searchMod.eDate = datePipe.transform(this.eDate, 'yyyy-MM-dd');*/

    this.passingModel.emit(this.searchItem);

  }

  searchTextClick() {
    this.searchTextChage.emit(this.selectedSearchID);
    //if(this.selectedSearchID == 'username' || this.selectedSearchID == 'all') {
      this.searchText = '';
    //}

  }
  seachOsTypeChange() {
    this.osTypeChange.emit(this.selectedOsType);
  }
  seachOsTypeChangeAction() {
    
    
  }

  onChage(event) {
    this.searchText = event.value;
  }

  // excelExport(event){
  //   this.excelDownStatus.emit(true);
  // }
  excelExport(event){
    this.excelDownStatus.emit(this.searchItem);
  }

  executeDBSync(event) {
    this.startDBSync.emit();
  }

  

}

@NgModule({
  imports:[DialogModule,BrowserModule,ButtonModule,CommonModule,DropdownModule,InputTextModule,HttpModule, RouterModule,FormsModule,CalendarModule,TranslatePipeMoudle],
  declarations:[SearchDropBoxComponent],
  exports:[SearchDropBoxComponent],
  providers:[]
})
export class SearchDropBoxModule{

}



// WEBPACK FOOTER //
// ./src/app/component/search_dropbox.component.ts